// context/SnackBarContext.jsx
import React, { createContext, useContext, useState } from "react";
import SnackBar from "./SnackBar";

const SnackBarContext = createContext();

export const SnackBarProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState(null);

  const showSnackbar = (type, message, duration = 5000) => {
    setSnackbar({ type, message });
    setTimeout(() => {
      setSnackbar(null);
    }, duration);
  };

  return (
    <SnackBarContext.Provider value={{ showSnackbar }}>
      {children}
      {snackbar && (
        <div className="fixed top-1 left-1/2 transform -translate-x-1/2 z-50">
          <SnackBar type={snackbar.type} message={snackbar.message} />
        </div>
      )}
    </SnackBarContext.Provider>
  );
};

export const useSnackBar = () => useContext(SnackBarContext);
